export const MobileRegex = /^(\+\d{1,3}[- ]?)?\d{10,15}$/;
export const EmailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
export const HasUpperCaseLetter = /[A-Z]/;
export const HasLowerCaseLetter = /[a-z]/;
export const HasSpecialChar = /[-_}:{=,+.''/*@!$#%&()^~]/;
export const HasNumber = /\d/;
